const ActionTypes = {
  GET_CANDIDATES_LIST: "GET_CANDIDATES_LIST",
  UPDATE_CANDIDATES_LIST: "UPDATE_CANDIDATES_LIST",
  GET_CANDIDATE_DETAILS: "GET_CANDIDATE_DETAILS",
  SET_CANDIDATE_PERSONAL_DETAILS: "SET_CANDIDATE_PERSONAL_DETAILS",
  UPDATE_CANDIDATE_QUALIFICATION_DETAILS:
    "UPDATE_CANDIDATE_QUALIFICATION_DETAILS",
  ADD_CANDIDATE_QUALIFICATION_DETAILS: "ADD_CANDIDATE_QUALIFICATION_DETAILS",
  DELETE_CANDIDATE_QUALIFICATION_DETAILS:
    "DELETE_CANDIDATE_QUALIFICATION_DETAILS",
  UPDATE_CANDIDATE_ADDRESS_DETAILS: "UPDATE_CANDIDATE_ADDRESS_DETAILS",
  UPDATE_CANDIDATE_ADDRESS_DETAILS_ALL: "UPDATE_CANDIDATE_ADDRESS_DETAILS_ALL",
  ADD_CANDIDATE_ADDRESS_DETAILS: "ADD_CANDIDATE_ADDRESS_DETAILS",
  UPDATE_CANDIDATE_ORGANIZATON_DETAILS: "UPDATE_CANDIDATE_ORGANIZATON_DETAILS",
  ADD_CANDIDATE_ORGANIZATON_DETAILS: "ADD_CANDIDATE_ORGANIZATON_DETAILS",
  DELETE_CANDIDATE_ORGANIZATON_DETAILS: "DELETE_CANDIDATE_ORGANIZATON_DETAILS",
  GET_GENDERS_LIST: "GET_GENDERS_LIST",
  GET_MARITAL_STATUS_LIST: "GET_MARITAL_STATUS_LIST",
  GET_STATES_LIST: "GET_STATES_LIST",
  RESET_CANDIDATE_DETAILS: "RESET_CANDIDATE_DETAILS",
  GET_RECRUITERS_LIST: "GET_RECRUITERS_LIST",
  GET_USER_ROLES: "GET_USER_ROLES"
};
export default ActionTypes;
